/**
 * Канонические ключи месяцев фискального года (Jul → Jun).
 *
 * UI рендерит названия через i18n (`idea_calc.months.<key>`), а в payload
 * мы пишем именно эти стабильные ключи — независимо от текущей локали.
 * Это нужно для XLSX-экспорта на бэкенде и для безопасного шеринга:
 * прежняя реализация писала `monthName: 'Июль'` независимо от языка
 * пользователя, что ломало en/uk-локали.
 */
export const FISCAL_MONTH_KEYS = [
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
] as const;

export type FiscalMonthKey = typeof FISCAL_MONTH_KEYS[number];

/** Полный i18n путь для каждого фискального месяца. */
export const FISCAL_MONTH_I18N_KEYS: readonly string[] = FISCAL_MONTH_KEYS.map(
  (k) => `idea_calc.months.${k}`
);

/**
 * Получить канонический ключ месяца по индексу 1..12 (фискальный порядок Jul=1).
 * Гарантирует, что в payload всегда уходит стабильный английский ключ,
 * который бэкенд может локализовать при экспорте.
 */
export function fiscalMonthKey(fiscalIndex: number): FiscalMonthKey {
  // Защищаемся от мусора в сохранённых данных — обрезаем в диапазон.
  const idx = Math.max(1, Math.min(12, Math.floor(fiscalIndex)));
  return FISCAL_MONTH_KEYS[idx - 1];
}
